import { ChangeDetectionStrategy, Component, computed, input, output, signal } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormControl, ReactiveFormsModule, Validators } from '@angular/forms';
import { DialogsModule } from '@progress/kendo-angular-dialog';
import { ButtonsModule } from '@progress/kendo-angular-buttons';
import { SubscribableProduct } from '../../../../../../services/billing.service';

/**
 * +Add Subscription dialog (F5 / ONE-3082). Minimal form: pick a base service the parent can
 * resell + a contracted count; the rate is resolved server-side from the parent's rate card and
 * shown here as a read-only preview. Emits the payload; the parent performs the create.
 */
@Component({
  selector: 'app-add-subscription-dialog',
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule, DialogsModule, ButtonsModule],
  templateUrl: './add-subscription-dialog.component.html',
  styleUrl: './add-subscription-dialog.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AddSubscriptionDialogComponent {
  public products = input.required<SubscribableProduct[]>();
  public saving = input<boolean>(false);
  public add = output<{ product_id: string; contracted_count: number }>();
  public close = output<void>();

  public productId = new FormControl<string>('', {
    nonNullable: true,
    validators: [Validators.required],
  });
  public count = new FormControl<number>(0, {
    nonNullable: true,
    validators: [Validators.required, Validators.min(0)],
  });

  public selectedId = signal<string>('');
  public selected = computed(
    () => this.products().find((p) => p.product_id === this.selectedId()) ?? null
  );

  public submit(): void {
    if (this.productId.invalid || this.count.invalid) return;
    this.add.emit({ product_id: this.productId.value, contracted_count: this.count.value });
  }
}
